import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../environments/environment.development';
import { RuntimeConfigService } from './runtime-config.service';
import { cleanText } from 'pdf-lib';

@Injectable({
  providedIn: 'root',
})
export class AesGcmEncryptionService {
  private readonly privateKey: any;
  private readonly secrateKey: any;
  private cryptoKeyPromise!: Promise<CryptoKey>;

  constructor(private configService: RuntimeConfigService) {
    // this.privateKey = CryptoJS.enc.Utf8.parse(
    //   this.configService.config.AesGcmPrivateKey,
    // );
    // this.secrateKey = CryptoJS.enc.Utf8.parse(
    //   this.configService.config.SecrateKey,
    // );
       this.privateKey = CryptoJS.enc.Utf8.parse(environment.AesGcmPrivateKey);
        this.secrateKey = CryptoJS.enc.Utf8.parse(environment.SecrateKey);
    this.initKey();
  }

  private initKey(): void {
    const base64Key = '1IiGe4rT/GuGBUKIcAaCQ1FSFQs+n3vfFG4zlnuQpt0=';
    const rawKey = Uint8Array.from(atob(base64Key), (c) => c.charCodeAt(0));

    this.cryptoKeyPromise = crypto.subtle.importKey(
      'raw',
      rawKey,
      { name: 'AES-GCM' },
      false,
      ['encrypt', 'decrypt'],
    );
  }

  encrypt(inputText: any): Promise<any> {
    const nonce = crypto.getRandomValues(new Uint8Array(12));
    var payload = {
      data: inputText,
      timestamp: new Date().toISOString()
    };
    const encoded = new TextEncoder().encode(JSON.stringify(payload));

    return this.cryptoKeyPromise.then((key) =>
      crypto.subtle
        .encrypt({ name: 'AES-GCM', iv: nonce, tagLength: 128 }, key, encoded)
        .then((buffer) => {
          const encryptedBytes = new Uint8Array(buffer);

          const tag = encryptedBytes.slice(encryptedBytes.length - 16);
          const cipherText = encryptedBytes.slice(
            0,
            encryptedBytes.length - 16,
          );

          const combined = new Uint8Array(
            nonce.length + tag.length + cipherText.length,
          );

          combined.set(nonce, 0);
          combined.set(tag, nonce.length);
          combined.set(cipherText, nonce.length + tag.length);

          return btoa(String.fromCharCode(...combined));
        }),
    );
  }

  decrypt(inputText: any): Promise<any> {
    const fullData = Uint8Array.from(atob(inputText), (c) => c.charCodeAt(0));

    const nonce = fullData.slice(0, 12);
    const tag = fullData.slice(12, 28);
    const cipherText = fullData.slice(28);

    const encryptedData = new Uint8Array(cipherText.length + tag.length);

    encryptedData.set(cipherText, 0);
    encryptedData.set(tag, cipherText.length);

    return this.cryptoKeyPromise.then((key) =>
      crypto.subtle
        .decrypt(
          { name: 'AES-GCM', iv: nonce, tagLength: 128 },
          key,
          encryptedData,
        )
        .then((buffer) => new TextDecoder().decode(buffer)),
    );
  }
}
